import React, { PropTypes } from 'react';

const StatusFilter = ({
    handleClick,
    selected,
    labels
}) => {
    const onClick = (event) => {
        event.preventDefault();
        const status = event.target.getAttribute('data-status');
        handleClick(status);
    };

    const options = Object.keys(StatusFilter.Options).map(key => {
        const option = StatusFilter.Options[key];
        return (
            <a
                key={option}
                className={`button-filter-alt med ${selected === option ? 'active' : ''}`}
                data-status={option}
                onClick={onClick}
            >
                {labels[option]}
            </a>
        );
    });

    return (
        <div className="form-group button-group tabbed" data-behavior="tabs">
            {options}
        </div>
    );
};

StatusFilter.Options = {
    LIVE: 'live',
    UPCOMING: 'upcoming',
    REPLAY: 'replay'
};

StatusFilter.propTypes = {
    selected: PropTypes.string,
    handleClick: PropTypes.func,
    labels: PropTypes.shape({
        [StatusFilter.Options.LIVE]: PropTypes.string,
        [StatusFilter.Options.UPCOMING]: PropTypes.string,
        [StatusFilter.Options.REPLAY]: PropTypes.string
    })
};

StatusFilter.defaultProps = {
    selected: StatusFilter.Options.LIVE
};

export default StatusFilter;



// WEBPACK FOOTER //
// ./app/common/schedule/StatusFilter.js